import Link from "next/link";
import { styled } from "@mui/material";
import { colors } from "@constants/cssVariables";

export const Hyperlink = styled(Link)({
  color: colors.primary,
});
